import { Component, Host, h, Prop, Event, EventEmitter } from '@stencil/core'
import { DropdownMenuItemClicked, ICON_TYPES, LINK_TARGETS } from '../../utils'

@Component({
  tag: 'snap-dropdown-menu-item',
  styleUrl: 'snap-dropdown-menu-item.scss',
  shadow: true,
})
export class SnapDropdownMenuItem {
  @Prop() active: boolean
  @Prop() icon: ICON_TYPES
  @Prop() badgeText: string | number
  @Prop() name: string
  @Prop() value: any
  @Prop() href: string
  @Prop() divider: boolean
  @Prop() target: LINK_TARGETS = '_self'

  @Event() dropdownMenuItemClicked: EventEmitter<DropdownMenuItemClicked>

  handleClick = () => {
    this.dropdownMenuItemClicked.emit({
      name: this.name,
      value: this.value,
      badgeText: this.badgeText as string,
    })
  }

  render() {
    const Tag = this.href ? 'a' : 'button'
    return (
      <Host
        class={{
          active: this.active,
          divider: this.divider,
        }}
        onClick={this.handleClick}>
        <li>
          <Tag class="wrapper" {...(!!this.href && { href: this.href, target: this.target })}>
            {!!this.icon && <snap-icon color="#64748B" size="sm" icon={this.icon} />}
            <slot></slot>
            {!!this.badgeText && <snap-indicator text={this.badgeText} />}
          </Tag>
        </li>
      </Host>
    )
  }
}
